import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgShareFilled = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 6a4 4 0 0 1-6.98 2.668l-5.081 2.63a4.024 4.024 0 0 1-.059 1.676l5.066 2.443a4 4 0 1 1-.87 1.801l-5.155-2.486a4 4 0 1 1 .183-5.255L14.1 6.893A4 4 0 1 1 22 6Z", fill: color }));
};
export default factorySvgIcon(SvgShareFilled);
//# sourceMappingURL=SvgShareFilled.js.map